import { defineStore } from 'pinia'

import api from '@/api/config.js'
import { parseToJson } from '@/utils/parser.js'

const mappedConfigs = (configs) => {
  const mappedConfigs = []
  for (const i in configs) {
    if (Object.prototype.hasOwnProperty.call(configs, i)) {
      const value = configs[i].value
      mappedConfigs[configs[i].id] = value
    }
  }
  return mappedConfigs
}

export const useConfigStore = defineStore('config', {
  state: () => ({
    businessAffiliateConfig: []
  }),
  actions: {
    getBusinessAffiliateConfig () {
      api.getBusinessAffiliateConfig()
        .then(response => {
          const configs = parseToJson(response.body.data.value)
          this.businessAffiliateConfig = mappedConfigs(configs)
        })
    }
  },
  getters: {
    verifyBankAccount: state => state.businessAffiliateConfig.verifyBankAccount,
    termsAndConditions: state => state.businessAffiliateConfig.termsAndConditions,
    invoiceGuide: state => state.businessAffiliateConfig.invoiceGuide,
    registrationViaBlibli: state => state.businessAffiliateConfig.registrationViaBlibli,
    downloadStatementFeatureFlag: state => state.businessAffiliateConfig.downloadStatementFeatureFlag,
    sellerCampaignGenerateLinkLimit: state => state.businessAffiliateConfig.sellerCampaignGenerateLinkLimit,
    generateIframeFeatureFlag: state => state.businessAffiliateConfig.generateIframeFeatureFlag
  }
})
